import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import GenericMedia from '@ids/components/Media';
import Heading from '@ids/components/Typography/Heading';

export const WhatYouGetSection = styled.section`
    display: grid;
    align-items: center;
    gap: 8vw 0;

    ${forTablet`
        grid-template-columns: repeat(2, 1fr);
    `}
`;

export const Media = styled(GenericMedia)`
    width: 100%;
    height: 100%;

    ${forTablet`
        grid-column: 1 / 2;
        grid-row: 1 / 1;
    `}
`;

export const TextBox = styled.div`
    text-align: center;
    padding: 0 4vw;

    ${Heading} {
        margin-bottom: 10px;
    }

    ${forTablet`
        text-align: left;
        grid-column: 2 / 3;
        grid-row: 1 / 1;
    `}
`;
